import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSection from '../components/sections/Services';

const Services = () => {
  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="title-wrapper">
            <h1>Our Services</h1>
            <p>Software development, cloud, design, mobile, integration, and security</p>
          </div>
        </div>
      </div>
      <ServicesSection />
    </>
  );
};

export default Services;
